import { render, staticRenderFns } from "./BaseActionButton.vue?vue&type=template&id=0462cf27&scoped=true"
import script from "./BaseActionButton.vue?vue&type=script&lang=js"
export * from "./BaseActionButton.vue?vue&type=script&lang=js"
import style0 from "./BaseActionButton.vue?vue&type=style&index=0&id=0462cf27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0462cf27",
  null
  
)

export default component.exports